// <pos-app/> — 根元件，路由分派的掛載點
// see architecture.md#L580

class PosApp extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    window.addEventListener('hashchange', () => this.render());
    // 登入狀態變化 → nav 顯示/隱藏（未登入不該露出功能列，TestFlight 實測回饋）
    window.addEventListener('auth:changed', () => this.render());
  }

  render() {
    const authed = document.body.dataset.authed === 'true';
    // 顧客面路由（QR 點餐/訂位/結帳結果）永遠不顯示店家 nav —
    // 店內平板已登入時給客人掃碼點餐，不能露出後台入口（QA 2026-07-07）
    const isCustomerRoute = /^#\/(order|reserve)\/|^#\/checkout\/result\b/.test(location.hash);
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; overflow-x: hidden; }
        /* grid-template-columns: minmax(0,1fr) → 欄寬不被寬內容撐開（防 grid blowout
           把 shell 撐爆 viewport，連帶 nav/卡片溢出） */
        .shell { display: grid; grid-template-rows: auto 1fr; grid-template-columns: minmax(0, 1fr); min-height: 100vh; }
      </style>
      <div class="shell">
        ${authed && !isCustomerRoute ? '<pos-nav></pos-nav>' : ''}
        <pos-auth-gate>
          <slot name="route"></slot>
        </pos-auth-gate>
      </div>
    `;
  }
}

customElements.define('pos-app', PosApp);
